(() => {
  'use strict';
  const ZONE = 'Europe/Paris';
  const LIMIT = 16;
  const HOLIDAYS = new Map();
  let observedDrawer = null;
  let drawerObserver = null;
  let queued = false;

  function key(year, month, day) {
    return [year, String(month).padStart(2, '0'), String(day).padStart(2, '0')].join('-');
  }
  function easter(year) {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(year, month - 1, day));
  }
  function holidayKeys(year) {
    if (HOLIDAYS.has(year)) return HOLIDAYS.get(year);
    const days = new Set(['01-01', '05-01', '05-08', '07-14', '08-15', '11-01', '11-11', '12-25'].map(d => year + '-' + d));
    const start = easter(year).getTime();
    [1, 39, 50].forEach(offset => {
      const date = new Date(start + offset * 86400000);
      days.add(key(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate()));
    });
    HOLIDAYS.set(year, days);
    return days;
  }
  function isWorkday(year, month, day) {
    const weekday = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
    return weekday >= 1 && weekday <= 5 && !holidayKeys(year).has(key(year, month, day));
  }
  function parisNow() {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date());
    const value = field => Number(parts.find(p => p.type === field).value);
    return { year: value('year'), month: value('month'), day: value('day'), hour: value('hour') };
  }
  function nextWorkday(now) {
    const base = Date.UTC(now.year, now.month - 1, now.day);
    for (let offset = 1; offset <= 16; offset += 1) {
      const date = new Date(base + offset * 86400000);
      const year = date.getUTCFullYear();
      const month = date.getUTCMonth() + 1;
      const day = date.getUTCDate();
      if (isWorkday(year, month, day)) return date;
    }
    return new Date(base + 86400000);
  }
  function message() {
    const now = parisNow();
    if (isWorkday(now.year, now.month, now.day) && now.hour < LIMIT) {
      return ['Commandez avant 16 h', 'Votre colis est remis au transporteur aujourd’hui.'];
    }
    const date = new Intl.DateTimeFormat('fr-FR', {
      weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC'
    }).format(nextWorkday(now));
    return ['Remise au transporteur : ' + date, 'Votre café est préparé et confié au transporteur dès le prochain jour ouvré.'];
  }
  function notice(name) {
    const note = document.createElement('div');
    note.className = 'pcf-prep-promise';
    note.dataset.pcfPrepLocation = name;
    const icon = document.createElement('span');
    icon.className = 'pcf-prep-promise__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '◷';
    const copy = document.createElement('span');
    copy.className = 'pcf-prep-promise__copy';
    const title = document.createElement('strong');
    const detail = document.createElement('span');
    copy.append(title, detail);
    note.append(icon, copy);
    return note;
  }
  function update(note, words) {
    if (!note) return;
    const stamp = words.join('|');
    if (note.dataset.pcfPrepStamp === stamp) return;
    note.dataset.pcfPrepStamp = stamp;
    note.querySelector('strong').textContent = words[0];
    note.querySelector('.pcf-prep-promise__copy > span').textContent = words[1];
  }
  function productNotice(words) {
    if (!location.pathname.startsWith('/products/') ||
        location.pathname.startsWith('/products/abonnement-cafe')) return;
    const root = document.getElementById('MainContent');
    if (!root) return;
    const shipping = root.querySelector('.pcf-product-shipping');
    const buy = root.querySelector('.product__buy-buttons');
    const anchor = shipping || buy;
    if (!anchor) return;
    let note = root.querySelector('[data-pcf-prep-location="product"]');
    if (!note) note = notice('product');
    if (shipping && note.nextElementSibling !== shipping) shipping.before(note);
    else if (!shipping && buy && buy.nextElementSibling !== note) buy.after(note);
    update(note, words);
  }
  function cartNotice(words) {
    const drawer = document.getElementById('pcf-cart-drawer');
    if (!drawer) return;
    const box = drawer.querySelector('.pcf-buybox');
    if (!box) return;
    const dock = box.querySelector('.pcp28-dock');
    const button = [...box.querySelectorAll('a, button')].find(el =>
      /passer au paiement|valider mon panier/i.test(el.textContent || ''));
    const anchor = dock || button;
    if (!anchor || !anchor.parentElement) return;
    let note = box.querySelector('[data-pcf-prep-location="cart"]');
    if (!note) note = notice('cart');
    if (note.nextElementSibling !== anchor) anchor.before(note);
    update(note, words);
  }
  function observeDrawer() {
    const drawer = document.getElementById('pcf-cart-drawer');
    if (!drawer || drawer === observedDrawer) return;
    if (drawerObserver) drawerObserver.disconnect();
    observedDrawer = drawer;
    drawerObserver = new MutationObserver(schedule);
    drawerObserver.observe(drawer, { childList: true, subtree: true });
  }
  function refresh() {
    queued = false;
    const words = message();
    productNotice(words);
    cartNotice(words);
    observeDrawer();
  }
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(refresh);
  }
  document.addEventListener('click', event => {
    if (!event.target.closest('#cart-icon-bubble, [data-pcf-cart-open], [data-cart-toggle]')) return;
    window.setTimeout(schedule, 80);
    window.setTimeout(schedule, 500);
  });
  document.addEventListener('pcf:cart-updated', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.setInterval(schedule, 30000);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
})();